// Single-column layout: the personal-info fields, then the CRM Contact card, then
// the Contact Information / Email section — each stacked in normal flow. The CRM
// card sits ABOVE Contact Information and can never overlap the spouse fields
// (which it previously did as a centered right-column overlay).
export const wrapperStyles = {
  display: 'flex',
  flexDirection: 'column',
  gap: '24px',
};

// CRM Contact card in normal flow above the Contact Information section.
// Width-capped so it reads as a card rather than a full-width band.
export const crmContactSectionStyles = {
  maxWidth: '520px',
};

export const contactsSectionStyles = {
  gridTemplateColumns: 'repeat(3, 1fr)',
  rowGap: '8px',
  width: 'calc(33% - 24px)',
};

export const phoneStyles = {
  flexDirection: 'row !important',
  alignItems: 'center',
  gap: '8px',

  '& .label': {
    margin: 0,
    padding: '9px 16px',
    width: '25%',
    borderRadius: '4px',
    backgroundColor: ({ palette }) => palette.background.hoverDefault,
    color: ({ palette }) => palette.text.primary,
  },

  '& .MuiFormControl-root': {
    flex: 1,
  },

  '& .helper-text': {
    display: 'flex',
    alignItems: 'center',
    height: '100%',
    left: 'calc(100% + 10px)',
    top: 0,
    padding: 0,
  },
};

export const phoneNumberExtensionStyles = {
  ...phoneStyles,

  '& .label': {
    margin: 0,
    padding: '9px 16px',
    width: '50%',
    borderRadius: '4px',
    backgroundColor: ({ palette }) => palette.background.hoverDefault,
    color: ({ palette }) => palette.text.primary,
  },
};
